
import React from 'react';
import { motion } from 'framer-motion';
import { Box } from 'lucide-react';

const Video3DWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="relative py-12">
      {/* 3D decorative elements */}
      <motion.div
        className="absolute -left-8 -top-8 text-primary/30"
        animate={{
          rotate: [0, 360],
          scale: [1, 1.2, 1],
        }}
        transition={{
          duration: 5,
          repeat: Infinity,
          ease: "linear"
        }}
      >
        <Box size={48} />
      </motion.div>
      
      <motion.div
        className="absolute -right-8 -bottom-8 text-primary/30"
        animate={{
          rotate: [360, 0],
          scale: [1, 1.2, 1],
        }}
        transition={{
          duration: 5,
          repeat: Infinity,
          ease: "linear"
        }}
      >
        <Box size={48} />
      </motion.div>

      {/* Floating particles */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(5)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute w-4 h-4 bg-primary/10 rounded-full"
            initial={{ 
              x: Math.random() * 100 - 50,
              y: Math.random() * 100 - 50 
            }}
            animate={{
              x: [Math.random() * 200 - 100, Math.random() * 200 - 100],
              y: [Math.random() * 200 - 100, Math.random() * 200 - 100],
            }}
            transition={{
              duration: 10,
              repeat: Infinity,
              repeatType: "reverse",
              ease: "linear",
              delay: i * 0.5
            }}
          />
        ))}
      </div>

      {children}
    </div>
  );
};

export default Video3DWrapper;
